/**
 * StudioForty9 custom Bundle Builder
 * Javascript assets
 */

if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}
if (typeof Shopify.theme === 'undefined') {
  Shopify.theme = {};
}
if (typeof Shopify.theme.jsBundleBuilder === 'undefined') {
  Shopify.theme.jsBundleBuilder = {
    domBuilder: false,
    domImages: false,
    domBar: false,
    jsonBundle: {},
    self: null,
    mediaQuery: window.matchMedia('(min-width: 1024px)'),
    initialised: false,
    bundleId: '',
    init: async function (all_product_exceeded) {
      self = this;

      /* Find and store the bundle builder DOM element */
      self.domBuilder = document.querySelector('[data-bundle-builder]') ?? false;
      if (self.domBuilder) {
        self.domBuilder.dataset.bundleBuilder = self;
        self.domImages = document.querySelector(self.domBuilder.dataset.bundleImages) ?? false;
        self.domBar = document.querySelector(self.domBuilder.dataset.bundleBar) ?? false;
        self.jsonBundle = JSON.parse(self.domBuilder.dataset.bundleJson);
        self.checkProductAvailability();
        [...self.domBuilder.querySelectorAll('[data-option-group]')].forEach(details => details.addEventListener('toggle', self.toggleOptionGroup));
        [...self.domBuilder.querySelectorAll('[data-bundle-option-input]')].forEach(input => input.addEventListener('change', self.selectOption));
        [...document.querySelectorAll('[data-add-to-cart][data-is-bundle="true"]')].forEach(btn => {
          //btn.removeAttribute("disabled");
          btn.addEventListener('click', self.addToCart);
        });
        window.addEventListener('scroll', self.stickItems);
        self.initialised = true;

        // Set default gallery image for iOS devices
        if (self.domImages) {
          setTimeout(() => {
            document.querySelector('[data-bundle-option-group-image="0"] input[type="radio"]').checked = true;
          }, 1000);
        }
      }
      document.addEventListener('e_ajax-cart-changed', self.updateCart);
      document.addEventListener('e_ajax-cart-opened', self.updateCart);

      // On remove master bundle from cart, remove all options
      document.addEventListener('click', event => {
        if (event.target.closest('[data-bundle-remove]') != null) {
          self.removeBundle(event.target.closest('[data-bundle-remove]'));
        }
      });
    },
    /**
     * First load functions
     */

    /**
     *  Load any missing option product images
     * only the first image in each option group is loaded to reduce calls to all_products[]
     **/
    loadImages: async () => {
      // check gallery thumbs
      // if src contains 'Liquid error' load currently set image for linked option group
      [...document.querySelectorAll(`${self.domBuilder.dataset.bundleImages} [data-bundle-option-group-image]`)].forEach((imageWrapper, idx, array) => {
        const group_id = imageWrapper.dataset.bundleOptionGroupImage;
        [...imageWrapper.querySelectorAll('img[src*="Liquid"]')].forEach(img => {
          const image_url = self.domBuilder.querySelector(`[data-option-group="${group_id}"] img.visible`)?.getAttribute('src');
          img.setAttribute('src', image_url);
          let zoom = imageWrapper.querySelector('[data-image-zoom]');
          if (zoom != null) {
            zoom.style.backgroundImage = `url(${image_url})`;
          }
        });
      });
    },
    selectDefaults: async () => {
      const promises = [...self.domBuilder.querySelectorAll('[data-option-group][data-option-mandatory="true"]')].map(group => {
        let checked = false;
        [...group.querySelectorAll('input[data-option-item]:not(:disabled)')].forEach((option, index) => {
          if (!option.disabled && !checked) {
            option.checked = true;
            self.selectOption({
              currentTarget: option,
              auto: false
            });
            checked = true;
          }
        });
      });
      await Promise.all(promises);
    },
    checkProductAvailability: () => {
      let bundleAvailable = true;
      [...self.domBuilder.querySelectorAll('[data-option-group][data-option-mandatory="true"]')].forEach(group => {
        const options = [...group.querySelectorAll('input[data-option-item]')],
          disabledOptions = [...group.querySelectorAll('input[data-option-item]:disabled')];
        if (options.length == disabledOptions.length) {
          // No options in stock / available
          let domTitle = group.querySelector('.bundle-builder__option-title [data-bundle-option-title]'),
            title = domTitle.innerHTML;
          domTitle.innerHTML = `${title} - <em><small>All options out of stock</small></em>`;
          bundleAvailable = false;
        }
      });
      if (!bundleAvailable) {
        self.disableAddToCart();
      }
    },
    checkMandatoryOptionsSelected: () => {
      const mandatoryOptionGroups = Array.from(self.domBuilder.querySelectorAll('.bundle-builder__option[data-option-mandatory="true"]'));
      let allMandatoryOptionsSelected = true;
      for (const option of mandatoryOptionGroups) {
        const selectedOption = option.querySelector('input[data-bundle-option-input]:checked');
        if (!selectedOption) {
          allMandatoryOptionsSelected = false;
          break;
        }
      }
      return allMandatoryOptionsSelected;
    },
    /**
     * Sticky UI element functions
     */

    stickItems: () => {
      self.stickGallery();
      self.stickBar();
    },
    // Stick gallery images on scroll, until scroll past bottom of bundle builder
    stickGallery: () => {
      if (self.mediaQuery.matches) {
        if (self.domImages !== false) {
          let builder_bottom = self.domBuilder.offsetTop + self.domBuilder.offsetHeight + 100,
            gallery = self.domImages.closest('.product__gallery');
          if (+self.domImages.dataset.defaultPosition == 0) {
            self.domImages.dataset.defaultPosition = gallery.offsetTop;
          }

          // dont stick if gallery taller than builder
          if (self.domImages.offsetTop + self.domImages.offsetHeight < builder_bottom - 100) {
            // if bottom of gallery reaches bottom of builder
            if (window.pageYOffset + self.domImages.offsetHeight >= builder_bottom) {
              gallery.classList.add('sticky-bottom');
            }
            // stick if top of gallery scrolls off screen
            else if (window.pageYOffset > self.domImages.dataset.defaultPosition) {
              gallery.classList.add('sticky');
              if (window.pageYOffset + self.domImages.offsetHeight < builder_bottom) {
                gallery.classList.remove('sticky-bottom');
              }
            } else {
              gallery.classList.remove('sticky-bottom');
              gallery.classList.remove('sticky');
            }
          }
        }
      }
    },
    // Sticky total bar at bottom of screen if price scrolls out of view
    stickBar: () => {
      if (self.domBar !== false) {
        threshold = document.querySelector('.product__information>form.product__form').offsetTop;
        if (!threshold) return;
        if (window.pageYOffset > threshold) {
          self.domBar.classList.add('sticky');
          document.querySelector('body').classList.add('bb_has-stuck-bar');
        } else {
          self.domBar.classList.remove('sticky');
          document.querySelector('body').classList.remove('bb_has-stuck-bar');
        }
      }
    },
    /**
     * UI interaction functions
     */

    toggleOptionGroup: event => {
      if (event.currentTarget.hasAttribute('open')) {
        const section = event.currentTarget.querySelector('input:checked');
        if (section != null) {
          // Select matching group thumbnail in gallery
          const image_toggle = self.domImages.querySelector(`[data-bundle-option-group-image="${section.dataset.optionGroup}"] input[type="radio"]`);
          if (image_toggle) image_toggle.checked = true;
        }
      }
    },
    selectOption: event => {
      const option = event.currentTarget,
        id = option.dataset.bundleOptionInput,
        group = option.dataset.optionGroup;

      // update option image
      [...self.domBuilder.querySelectorAll(`[data-option-group="${group}"] [data-option-image]`)].forEach(image => image.dataset.optionImage == id ? image.classList.add('visible') : image.classList.remove('visible'));

      // update selected option description
      let text = self.domBuilder.querySelector(`[data-option-group="${group}"] [data-selected-option-title]`) ?? false;
      if (text) text.textContent = option.dataset.optionTitle;
      let title = self.domBuilder.querySelector(`[data-option-group="${group}"] .bundle-builder__option-selected `);
      if (title) title.classList.remove('hidden');
      let charge = self.domBuilder.querySelector(`[data-option-group="${group}"] [data-selected-option-charge]`) ?? false;
      if (charge) {
        charge.textContent = +option.dataset.optionCharge > 0 ? `+ ${Utils.formatMoney(+option.dataset.optionCharge)}` : '';
      }
      self.calculateTotal();

      // update main product image stack
      if (self.domImages) {
        let image_url = self.domBuilder.querySelector(`[data-option-group="${group}"] .visible[data-option-image]`)?.getAttribute('src');
        [...self.domImages.querySelectorAll(`[data-bundle-option-group-image="${group}"]`)].forEach(imageWrapper => {
          [...imageWrapper.querySelectorAll('img')].forEach(img => {
            img.closest('.blank-image')?.classList.remove('blank-image');
            img.setAttribute('src', image_url);
          });
          let zoom = imageWrapper.querySelector('[data-image-zoom]');
          if (zoom != null) {
            zoom.style.backgroundImage = `url(${image_url})`;
          }
          // Only toggle the gallery image on user select - not init()
          if (true != event?.auto) {
            let radio = imageWrapper.querySelector('input[type="radio"]');
            if (radio != null) {
              radio.checked = true;
            }
          }
        });
      }
      if (self.checkMandatoryOptionsSelected()) {
        self.enableAddToCart();
      }
    },
    disableAddToCart: () => {
      [...document.querySelectorAll('[data-product-information] [data-add-to-cart]')].forEach(button => button.disabled = true);
    },
    enableAddToCart: () => {
      [...document.querySelectorAll('[data-product-information] [data-add-to-cart]')].forEach(button => button.removeAttribute('disabled'));
    },
    /**
     * PDP display functions
     */

    calculateTotal: () => {
      let start_price = +self.domBuilder.dataset.bundlePrice,
        compare_at_price = +self.domBuilder.dataset.bundleComparePrice,
        bundle_total = 0;

      // get all selected options && sum selected option charges
      [...self.domBuilder.querySelectorAll('[data-bundle-option-input]:checked:not([value="-1"])')].forEach(option => bundle_total += +option.dataset.optionCharge * 100);

      // update regular_price & compare_at_price
      [...document.querySelectorAll(self.domBuilder.dataset.bundleTotalPrice)].forEach(el => el.textContent = Utils.formatMoney(((el.matches(self.domBuilder.dataset.bundleTotalPrice.split(',')[0]) ? start_price : compare_at_price) + bundle_total) / 100));
    },
    /**
     * Mini cart functions
     */

    addToCart: event => {
      event.preventDefault();
      const button = event.currentTarget,
        targetForm = button.closest('form');
      let qtyInput = targetForm.querySelector('[data-quantity-input]');
      if (!qtyInput) {
        const productId = targetForm.id;
        qtyInput = document.querySelector(`form.product__form[id="product_form_${productId}"] [data-quantity-input]`);
      }
      const qty = qtyInput ? qtyInput.value : 1,
        now = new Date();
      const parentVariantId = `gid://shopify/ProductVariant/${self.domBuilder.dataset.bundleVariantId}`;
      self.bundleId = `${self.domBuilder.dataset.bundleId}-${now.getTime()}`;
      let charge = 0,
        items = [...[...document.querySelectorAll('[data-bundle-option-input]:checked:not([value="-1"])')].map((option, index) => {
          charge += +option.dataset.optionCharge * 100;
          return {
            id: +option.value,
            quantity: +qty,
            properties: {
              // As per SOW
              _bundleParent: false,
              _bundleMainOption: index == 0 ? true : false,
              _bundleId: `${self.bundleId}`,
              _bundleLinePrice: option.dataset.optionCharge,
              // Legacy
              _bundled_with: self.domBuilder.dataset.bundleTitle,
              _bundle_item_price_hash: option.dataset.optionChargeHash,
              _bundle_item_qty_hash: option.dataset.optionQtyHash,
              _parentVariantId: parentVariantId,
              _parentInitialPriceHash: self.domBuilder.dataset.bundlePriceHash,
              _bundle_size: document.querySelectorAll('[data-bundle-option-input]:checked:not([value="-1"])').length
            }
          };
        }).reverse()];
      if (items.length > 0) {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items
          })
        }).then(response => response.json()).then(json => {
          if (json.hasOwnProperty('status')) {
            console.warn('Bundle add to cart failure');
            self.error(json.description);
          } else if (json?.items.length > 0) {
            Shopify.theme.jsCartCounter.update();
            Shopify.theme.jsAjaxCart.onCartChange();
            Shopify.theme.jsAjaxCart.openCart();
          }
        }).catch(error => {
          console.error('Bundle add to cart error: ', error);
          self.disableAddToCart();
          self.error(error);
        });
      }
      return false;
    },
    cleanCart() {
      // Check for orphaned bundle items
      let affected_items = {
        updates: {}
      };
      [...document.querySelectorAll('[data-bundle-item]:not([data-cart-item])')].forEach(item => {
        const bundleId = item.dataset.bundleItem;
        if (document.querySelectorAll(`[data-cart-item][data-bundle-item="${bundleId}"]`).length == 0) {
          affected_items.updates[item.querySelector('[data-bundle-remove]').dataset.bundleRemove] = 0;
        }
      });

      // Check for widowed bundle parent items
      [...document.querySelectorAll(`[data-cart-item][data-bundle-item]`)].forEach(parent => {
        const bundle_id = parent.dataset.bundleItem,
          child_list = document.querySelectorAll(`.cart__item-list .cart__item.bundle__item[data-bundle-item="${bundle_id}"]`);
        if (!child_list || child_list.length < 1) {
          affected_items.updates[parent.querySelector('[data-bundle-remove]').dataset.bundleRemove] = 0;
        }
      });
      if (Object.keys(affected_items.updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(affected_items)
        }).then(() => Shopify.theme.jsAjaxCart.loadCartContents()).catch(error => `Bundle removal error: ${error}`);
      }
    },
    updateCart() {
      // self.cleanCart();
      let subtotal = 0;
      [...document.querySelectorAll('[data-ajax-cart-contents] [data-cart-item]')].forEach(lineitem => {
        let qty_item = lineitem.querySelector('[data-cart-item-quantity]'),
          qty = qty_item != null ? qty_item.value : 1,
          price = lineitem.querySelector('[data-price-current]').dataset.priceCurrent ?? 0;
        subtotal += qty * price;
        lineitem.querySelector('[data-price-current]').innerText = Utils.formatMoney(price / 100);
      });
      [...document.querySelectorAll('[data-ajax-cart-contents] [data-cart-total]')].forEach(subtotal_item => subtotal_item.innerText = Utils.formatMoney(subtotal / 100));
    },
    // Remove complete bundle from cart including all option products
    removeBundle(target) {
      const bundle_id = target.closest('[data-cart-item]').dataset.bundleItem;
      let affected_items = {
        updates: {}
      };
      [...document.querySelectorAll(`[data-ajax-cart-contents] [data-bundle-item="${bundle_id}"] [data-bundle-remove]`)].forEach(item => {
        affected_items.updates[item.dataset.bundleRemove] = 0;
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(affected_items)
      }).then(() => Shopify.theme.jsAjaxCart.loadCartContents()).catch(error => `Bundle removal error: ${error}`);
    },
    error: error => {
      const cartError = document.querySelector('[data-product-information] [data-cart-error]');
      if (cartError != null) {
        cartError.innerHTML = `<p class="cart-warning__message animated bounceIn">${error}</p>`;
      } else {
        throw Error(error);
      }
    }
  };
}
